import Cookie from '@nuxt-common/util/app/utils/cookie/Cookie.js';
import { getUserGuid } from '#utils/UserDetails';
import { getError, getErrorMessage } from '#utils/ErrorHandler';
import { defineStore } from 'pinia';
import $http from '@vue-util/http';

const WISHLIST_ENDPOINT = '/xapi/wishlist/v1/lists';

export const useSendPriceAlertStore = defineStore('sendPriceAlert', {
  state: () => ({
    sendPriceAlertError: null,
    sendPriceAlertLoadingState: false,
    sendPriceAlertErrorStatus: false,
  }),
  actions: {
    async sendPriceAlert({ payload, listGuid, headers }) {
      this.sendPriceAlertLoadingState = true;
      this.sendPriceAlertErrorStatus = false;
      this.sendPriceAlertError = null;
      try {
        const response = await $http.put(`${WISHLIST_ENDPOINT}/${listGuid}?userGuid=${getUserGuid()}`, payload, {
          headers,
        });
        const responseData = response.data || response;
        if (getError(responseData)) {
          const errorMessage = getErrorMessage(responseData);
          this.sendPriceAlertError = errorMessage;
        }
      } catch (error) {
        if (error.response?.status === 401) {
          Cookie.set('SignedIn', '0');
          this.sendPriceAlertErrorStatus = true;
        }
        const fallbackErrorMessage = getErrorMessage(error.response?.data);
        this.sendPriceAlertError = fallbackErrorMessage;
      } finally {
        this.sendPriceAlertLoadingState = false;
      }
    },
    setSendPriceAlertError(error) {
      this.sendPriceAlertError = error;
    },
    setSendPriceAlertLoadingState(loadValue) {
      this.sendPriceAlertLoadingState = loadValue;
    },
    setSendPriceAlertErrorStatus(value) {
      this.sendPriceAlertErrorStatus = value;
    },
  },
});
